import { GlobalStore } from "../../../store/global/GlobalStore";
import bebopBinocularsImage from "../../../img/trade-interface/bebop_binoculars.png";
import { Spacer } from "../../general/Spacer/Spacer";
import { Text } from "../../general/Text";
import styled from "@emotion/styled";

export const CannotFindTokenInfo = ({ searchString }: { searchString: string }) => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <CannotFindTokenInfoContainer>
      <img src={bebopBinocularsImage} alt="Googly-eyed binoculars" width={150} />
      <Spacer height={26} />
      <div style={{ width: "95%", overflowWrap: "break-word" }}>
        <Text as={"div"} textStyle="Title" size="XS">
          We can't find a token for{" "}
          <span style={{ color: theme.font.primary.default }}>'{searchString}'</span>
        </Text>
        <Spacer height={6} />
        <Text as={"div"} textStyle="Title" size="XS">
          Try editing your search or switch networks
        </Text>
      </div>
    </CannotFindTokenInfoContainer>
  );
};

const CannotFindTokenInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  color: ${({ theme }) => theme.font.tertiary.default};
  text-align: center;
`;
